//imports
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Typography,
  Tooltip,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import { useSelector } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import { CUSTOMER_API_01, STOCK_API_02 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import {
  currencyFormat,
  currencyFormatLKR,
  customFormat,
} from "../../../src/utils/common/CurrencyFormat";
import {
  AlternateEmail,
  CalendarMonth,
  Description,
  Download,
  ImportContacts,
  LocalPhone,
  LocationCity,
  Person,
} from "@mui/icons-material";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
const StockDetailsPopup = ({ open, onClose, item }) => {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [itemDetails, setItemDetails] = useState([]);
  const [grnDetails, setgrnDetails] = useState([]);
  const [data,setData] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  
  const { COMPCODE, USERNAME,LOCCODE,
          RESTCODE,  } = SYS_USER.USER_PARAM || {};
  const handleClose = () => {
    onClose();
  };
  const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));

  useEffect(() => {
    if (item) {
      fetchData();
    }
  }, [item]);
  function generate(element) {
    return [0, 1, 2].map((value) =>
      React.cloneElement(element, {
        key: value,
      })
    );
  }

const fetchData = async () => {
  try {
    const result = await externalgetApi(STOCK_API_02, "get", {
      GRNNO: item.GRNNO,
    });
    console.log("gggggggggg", result);
    setItemDetails(result || []);  

 
    setgrnDetails(result|| []);
    setIsLoading(false);
  } catch (err) {
    setError(err);
    setIsLoading(false);
  }
};

useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(CUSTOMER_API_01, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE
      });

      console.log('xxxx', result);

      // ✅ FILTER HERE
      const filteredData = result.filter(
        (X) => X.SUPREFCODE === item.SUPREFCODE
      );
     
      setData(filteredData);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  fetchData();
}, [item.SUPREFCODE]);

  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={styles.popup_title}>GRN Item Details</DialogTitle>
      <DialogContent sx={styles.popup_content}>
        <Grid container spacing={2} marginBottom={2}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ mt: 1, mb: 1 }} variant="h6" component="div">
              Supplier Details
            </Typography>
            <Demo>
              <List dense={dense}>
             {grnDetails && grnDetails.length > 0 && (
                  <>
                    <ListItem>
                      <ListItemIcon>
                        <Person Tooltip="Supplier Name" />
                      </ListItemIcon>
                  <ListItemText
                  primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }}
  primary={`${data?.[0]?.TITLE || ""} ${data?.[0]?.FIRSTNAME || ""} ${data?.[0]?.LASTNAME || ""}`}
/>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <LocalPhone Tooltip="Contact Number" />     
                      
                      </ListItemIcon>
                      <ListItemText primary={data?.[0]?.CONTACTNO}
                      primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <AlternateEmail Tooltip="Email" />
                      </ListItemIcon>
                      <ListItemText primary={data?.[0]?.EMAIL}
                      primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <LocationCity Tooltip="Address" />
                      </ListItemIcon>
                    <ListItemText
                    primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }}
  primary={`${data?.[0]?.ADDRESSLINE1 || ""}${data?.[0]?.ADDRESSLINE2 ? ", " + data?.[0]?.ADDRESSLINE2 : ""}${data?.[0]?.ADDRESSLINE3 ? ", " + data?.[0]?.ADDRESSLINE3 : ""}`}
/>
                    </ListItem>
                  </>
                )}
              </List>
            </Demo>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={{ mt: 1, mb: 1 }} variant="h6" component="div">
              Invoice Details
            </Typography>
            <Demo>
              <List dense={dense}>
               {grnDetails && grnDetails.length > 0 && (
                  <>
                    <ListItem>
                      <ListItemIcon>
                        <CalendarMonth Tooltip="Invoice Date" />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.INVOICEDATE}
                         primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <Description Tooltip="Invoice Number" />
                      </ListItemIcon>
                      <ListItemText primary={item.INVOICENO}
                      primaryTypographyProps={{
    fontSize: "14px", // change size here
    
  }}
                      />
                    </ListItem>
                  </>
                )}
              </List>
            </Demo>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table aria-label="item details">
            <TableHead>
              <TableRow>
                <TableCell align="left">Item</TableCell>
                <TableCell align="left">Quantity</TableCell>
                <TableCell align="right">Sell Price</TableCell>
                <TableCell align="center">Expiry</TableCell>
                <TableCell align="right">Tax</TableCell>
                <TableCell align="right">Discount</TableCell>
                {/* <TableCell align="right">Attachment</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
           

              {Array.isArray(itemDetails) && itemDetails.length > 0 ? (
  itemDetails.map((detail, index) => (
          <TableRow key={index}>
                    <TableCell
                      align="left"
                      sx={{
                        maxWidth: "100px",
                        overflow: "hidden", // Hide the overflowed text
                        whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Tooltip title={detail.MENUNAME} arrow>
                        <span>{detail.MENUNAME}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">{detail.QTY}</TableCell>
                    <TableCell align="right">
                      {currencyFormat(detail.RATE)}
                    </TableCell>
                    <TableCell align="center">{detail.EXPIRY}</TableCell>
                    <TableCell align="right">
                      {currencyFormat(detail.TAXAMT)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormat(detail.DISCOUNT)}
                    </TableCell>
                    {/* <TableCell align="right">
                      <Tooltip title="Download">
                        <IconButton>
                          <Download sx={{ cursor: "pointer" }}></Download>
                        </IconButton>
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
  ))
) : (
  !isLoading && (
    <TableRow>
      <TableCell colSpan={6} align="center">
        No item details available.
      </TableCell>
    </TableRow>
  )
)}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        {/* <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            textTransform: "capitalize",
            letterSpacing: "1px",
          }}
        >
          Download Attachment
          <Download></Download>
        </Button> */}
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            textTransform: "capitalize",
            letterSpacing: "1px",
            width: "80px",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockDetailsPopup;
